// @ts-nocheck
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Get } from "../../utils/apiUtils";

export const OrganisationExtraReducer = (builder) => {
    builder
        .addCase(getOrganisations.pending, (state) => {
            state.loadStatus = 'loading';
        })
        .addCase(getOrganisations.fulfilled, (state, action) => {
            state.loadStatus = 'success';
            state.dataSource = action.payload.data;
            state.columns = action.payload.listMeta;
        })
        .addCase(getOrganisations.rejected, (state) => {
            state.loadStatus = 'failed';
        });
}

export const getOrganisations = createAsyncThunk(
    'org/getList',
    async () => {
        return await Get('/org', {msgKey: 'orgs'});
    }
  );
  